<template>
  <base-page>
    <div class="rps_12e0">
      <div class="x_container">
      <div>
        <img src="../assets/thanks.svg" width="140" alt="green"><br>
        <img style="margin: 3em auto;" src="../assets/thankyou.svg" width="228" alt="green">
      </div>

      <table>
        <tr>
          <td><img :id="workloadValues.id" :src="workloadValues.src" width="45" height="45" alt=""></td>
          <td class="td-left"><p>{{ workloadValues.text }}</p></td>
        </tr>
        <tr>
          <td><img :id="happinessValues.id" :src="happinessValues.src" width="45" height="45" alt=""></td>
          <td class="td-left"><p>{{ happinessValues.text }}</p></td>
        </tr>
        <tr>
          <td><img :id="goalsValues.id" :src="goalsValues.src" width="45" height="45" alt=""></td>
          <td class="td-left"><p>{{ goalsValues.text }}</p></td>
        </tr>
        <tr>
          <td><img :id="knowledgeValues.id" :src="knowledgeValues.src" width="45" height="45" alt=""></td>
          <td class="td-left"><p>{{ knowledgeValues.text }}</p></td>
        </tr>
      </table>

      </div>
      <img style="margin: 3em;" src="../assets/nice-week.png" alt="">
    </div>
  </base-page>
</template>

<script>

export default {
  name: 'thanks',
  data () {
    return {
      happinessOptions: [
        {
          id: 'green-face',
          src: require('../assets/green-face.svg'),
          value: '1',
          text: 'This week I felt good'
        },
        {
          id: 'blue-face',
          src: require('../assets/blue-face.svg'),
          value: '2',
          text: 'This week I felt normal'
        },
        {
          id: 'yellow-face',
          src: require('../assets/yellow-face.svg'),
          value: '3',
          text: 'This week I felt normal'
        },
        {
          id: 'red-face',
          src: require('../assets/red-face.svg'),
          value: '4',
          text: 'This week I felt angry'
        }
      ],
      workloadOptions: [
        {
          id: 'wl-green',
          src: require('../assets/wl-green.svg'),
          text: 'I will be mostly free',
          value: '1'
        },
        {
          id: 'wl-orange',
          src: require('../assets/wl-orange.svg'),
          text: 'I will be busy, but I can help others.',
          value: '2'
        },
        {
          id: 'wl-red',
          src: require('../assets/wl-red.svg'),
          text: 'I won\'t have time to help others',
          value: '3'
        },
        {
          id: 'wl-black',
          src: require('../assets/wl-black.svg'),
          text: 'I will be very busy and will need help.',
          value: '4'
        },
        {
          id: 'wl-white',
          src: require('../assets/wl-white.svg'),
          text: 'I won\'t be available (vacations, etc).',
          value: '0'
        }
      ],
      goalsOptions: [
        {
          id: 'fourstar-g',
          src: require('../assets/4-star.svg'),
          value: '1',
          text: 'This week I have achieved all my goals'
        },
        {
          id: 'threestar-g',
          src: require('../assets/3-star.svg'),
          value: '2',
          text: 'This week I almost achieve all my goals'
        },
        {
          id: 'twostar-g',
          src: require('../assets/2-star.svg'),
          value: '3',
          text: 'This I did not achieved many goals'
        },
        {
          id: 'onestar-g',
          src: require('../assets/1-star.svg'),
          value: '4',
          text: 'This week I did not achieve my goals'
        }
      ],
      knowledgeOptions: [
        {
          id: 'fourstar-k',
          src: require('../assets/4-star.svg'),
          value: '1',
          text: 'This week I have learned a lot.'
        },
        {
          id: 'threestar-k',
          src: require('../assets/3-star.svg'),
          value: '2',
          text: 'This week I have learn things.'
        },
        {
          id: 'twostar-k',
          src: require('../assets/2-star.svg'),
          value: '3',
          text: 'This week I could have learn more.'
        },
        {
          id: 'onestar-k',
          src: require('../assets/1-star.svg'),
          value: '4',
          text: 'This week I did not learn anything.'
        }
      ],
      happinessValues: {},
      workloadValues: {},
      goalsValues: {},
      knowledgeValues: {}
    }
  },
  mounted () {
    const {userId, workload, goals, happiness, knowledge, week} = this.$router.currentRoute.query
    this.userId = userId
    this.workload = workload
    this.goals = goals
    this.happiness = happiness
    this.knowledge = knowledge
    this.week = week

    this.happinessValues = this.happinessOptions.find(option => { return option.value === this.happiness })
    this.workloadValues = this.workloadOptions.find(option => { return option.value === this.workload })
    this.goalsValues = this.goalsOptions.find(option => { return option.value === this.goals })
    this.knowledgeValues = this.knowledgeOptions.find(option => { return option.value === this.knowledge })
    console.log('knowledge:', this.knowledgeValues)
    console.log('goals:', this.goalsValues)
    console.log('happines', this.happinessValues)
    console.log('workload:', this.workloadValues)
  },
  methods: {
    /*     happinessValues () {
      return this.happinessOptions.find(option => { return option.value === this.happiness })
    },
    workloadValues () {
      return this.workloadOptions.find(option => { return option.value === this.workload })
    },
    goalsValues () {
      return this.goalsOptions.find(option => { return option.value === this.goals })
    },
    knowledgeValues () {
      return this.knowledgeOptions.find(option => { return option.value === this.knowledge })
    } */
  }
}
</script>

<style>
#app {
  margin-top: 0px !important;
}
body {
  background: #17445F;
  margin: 0;
  font-family: 'Helvetica', 'Neue';
}
.x_cabecera {
  color: #FFF;
  font-size: 13px;
  background-color: #17445F;
  text-align: center;
  padding: .5em;
}

h1 {
  margin: 0px;
}
.rps_12e0 {
  margin-top: 2em !important;
}
.rps_12e0 .x_container {
  margin: 20px;
  border: 0px;
  text-align: center;
  background-color: #17445F;
  font-size: 12px;
}
.rps_12e0 .x_container2 {
  width: 100%;
  margin: 20px;
  border: 0px;
  text-align: left;
  color: #FFF;
  font-size: 12px;
  padding-bottom: 20px;
}
.link-no-style {
  text-decoration: none;
  color: #FFF;
}
.rps_12e0 .x_block > p {
  width: 280px;
  max-width: 280px;
  margin-left: 1em;
  text-align: left;
}
.rps_12e0 .x_block {
  background-color: #17445F;
  border: 0px;
  text-align: center;
  color: #fff;
  max-height: 150px;
  vertical-align: middle;

  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1em auto;
}
.rps_12e0 .x_fecha{
  background: #2C556E;
  padding: 10px 0 10px 15px;
  color: #fff;
  font-size: 12px;
  text-align: left;
}
.x_block > p {
  font-weight: bold;
  font-size: 14px;
}
@media (max-width: 600px) {
  .rps_12e0 .x_container {
    display: inherit !important;
  }
}
/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation:portrait) {
  table {
    width: 100% !important;
    min-width: 100% !important;
  }
}
@media only screen and (min-device-width : 320px) and (max-device-width : 812px) and (orientation:landscape) {
  table {
    width: 50% !important;
    min-width: 50% !important;
  }
}

table {
  margin: 0px auto !important;
  font-size: 14px;
  text-align: left;
  color: #FFF;
  min-width: 25%;
  width: 25%;
}
td {
  padding: .5em;
}
td img {
  text-align: center !important;
}
.td-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Thanks.vue